import { render, staticRenderFns } from "./CustomNotifications.vue?vue&type=template&id=4c64d654&scoped=true&lang=pug"
import script from "./CustomNotifications.vue?vue&type=script&lang=js"
export * from "./CustomNotifications.vue?vue&type=script&lang=js"
import style0 from "./CustomNotifications.vue?vue&type=style&index=0&id=4c64d654&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c64d654",
  null
  
)

export default component.exports